export class User {
  accessToken: string;
  isLogged = false;
  modelId: number;
  modelName: string;
  modelRole: string;
  modelCode: string;
  refreshToken: string;
  userId: number;
  username: string;
}
